/** Enlaces de WhatsApp (gratis): abren WhatsApp con el mensaje escrito; la persona solo toca Enviar. */

/** Número en formato internacional; en México, 10 dígitos → 52 + número. */
export const whatsappNumber = (phone: string) => {
  const d = phone.replace(/\D/g, '');
  return d.length === 10 ? `52${d}` : d;
};

/** Chat directo con una persona (con mensaje opcional). */
export const whatsappTo = (phone: string, text?: string) => `https://wa.me/${whatsappNumber(phone)}${text ? `?text=${encodeURIComponent(text)}` : ''}`;

/** Compartir un mensaje eligiendo el chat o grupo en WhatsApp. */
export const whatsappShare = (text: string) => `https://wa.me/?text=${encodeURIComponent(text)}`;
